import { TAnalyticsOfferStatus } from '../../types/analytics';

export function getAnalyticsOfferStatus(isNewOffer: boolean): TAnalyticsOfferStatus {
  return isNewOffer ? 'New_ad' : 'Edit_ad';
}
